import React, { useEffect, useState } from 'react';
import SideNavigation from '../components/SideNavigation';
import Header from '../components/Header';
import EditProfileTab from '../components/EditProfileTab';
import ChangePasswordTab from '../components/ChangePasswordTab';

const Settings = () => {
  const [activeTab, setActiveTab] = useState('edit-profile');

  useEffect(() => {
    document.title = 'Loan Mantra - Settings';
  }, []);

  return (
    <>
      <SideNavigation />

      <Header title="Settings" />

      <div className="dashboard-wrap">
        <div className="lm-nav-tabs padding-reg pb-0 pt-2">
          <ul className="nav nav-tabs" id="laTab" role="tablist">
            <li className="nav-item">
              <button
                className={`nav-link ${activeTab === 'edit-profile' ? 'active' : ''}`}
                id="edit-profile-tab"
                type="button"
                role="tab"
                aria-controls="edit-profile"
                aria-selected={activeTab === 'edit-profile'}
                onClick={() => setActiveTab('edit-profile')}
              >
                Edit Profile
              </button>
            </li>
            <li className="nav-item">
              <button
                className={`nav-link ${activeTab === 'change-password' ? 'active' : ''}`}
                id="change-password-tab"
                type="button"
                role="tab"
                aria-controls="change-password"
                aria-selected={activeTab === 'change-password'}
                onClick={() => setActiveTab('change-password')}
              >
                Change Password
              </button>
            </li>
          </ul>
        </div>

        <div className="padding-reg">
          <div className="tab-content" id="laTabContent">
            <div
              className={`tab-pane fade ${activeTab === 'edit-profile' ? 'show active' : ''}`}
              id="edit-profile"
              role="tabpanel"
              aria-labelledby="edit-profile-tab"
            >
              <EditProfileTab />
            </div>

            <div
              className={`tab-pane fade ${activeTab === 'change-password' ? 'show active' : ''}`}
              id="change-password"
              role="tabpanel"
              aria-labelledby="change-password-tab"
            >
              <ChangePasswordTab />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Settings;
